import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMap from './components/Map.vue'

if (document.getElementById('vue-map')) {

  Vue.use(VueGoogleMaps, {
    load: {
      key: _.get(window, 'map.apiKey', '')
    }
  })
  
  var MapComponent = Vue.extend(VueMap)
  var _Map = new MapComponent().$mount('#vue-map')

  // custom events
  $(_Map.$el).on('mouseleave', {$vue: _Map}, function (event) {
    event.data.$vue.toggleAllInactive()
  })
}


// WEBPACK FOOTER //
// ./src/js/map.js